<template>
	<!--单项选择题-->
	<div @click="setEditIndex(index)" class="duoxuan">
		<el-row :gutter="10" style="margin-left: 5px">
			<el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">{{ number }}</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
				<contenteditable-div class="title-input" @focus="showAdvance" @blur="updateQuestion()" v-model="question.questionsName">
					{{ question.questionsName }}
				</contenteditable-div>
				<div v-if="question.optionRelationTips != ''" style="color: #ccc">{{ question.optionRelationTips }}</div>
			</el-col>
			<el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
				<i class="el-icon-delete delete" v-if="index == editIndex" @click="questiondel(question.id)"></i>
				<el-badge v-if="question.displayscriptcount || question.jumpscriptcount" :value="question.displayscriptcount + question.jumpscriptcount" class="item">
					<i class="el-icon-share" @click="() => $emit('jumpshow', question.id)"></i>
				</el-badge>
				<i class="el-icon-rank item drag-handle"></i>
			</el-col>
		</el-row>

		<div v-if="question.ifGrouping == 1">
			<!-- 单选 -->
			<div v-if="question.ifMustSingle == 1" style="width: 1000px">
				<div v-if="question.choiceLayout == 1">
					<el-row :gutter="10" style="margin-top: 12px !important" v-for="(childItem, childindex) in question.groupingOptionList" :key="index + '_' + childindex">
						<p style="font-size: 14px; width: 100px; margin-left: 50px">{{ childItem.groupName }}</p>
						<div @click="setEditOptionIndex(childindex)" v-for="(option, optionindex) in childItem.questionsOptionVOS" :key="optionindex" style="margin-left: 70px">
							<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="el_item_option item_container_title">
								<el-radio label="1">
									<el-input placeholder="选项1" @focus="showAdvance" v-model="option.labelName" @blur="wjupdoption(option)"></el-input>
									<input type="text" v-if="childItem.ifFillEmpty == 1" class="inputStyle" />
								</el-radio>
								<i
									class="el-icon-s-tools el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjsetquestionoption(question.groupingOptionList, childItem, childindex)"
								></i>
								<i
									class="el-icon-remove el-icon-common-option"
									v-if="editOptionIndex == index + '_' + optionindex"
									@click="wjdelquestionoption(question.groupingOptionList, option, optionindex)"
								></i>
							</el-col>
						</div>
					</el-row>
				</div>
				<div
					v-if="question.choiceLayout == 2"
					style="
            display: flex;
            margin-left: 34px;
            width: 1000px;
            flex-wrap: wrap;
          "
				>
					<el-row :gutter="10" style="margin-top: 12px !important" v-for="(childItem, childindex) in question.groupingOptionList" :key="index + '_' + childindex">
						<p style="font-size: 14px; width: 100px; margin-left: 50px">{{ childItem.groupName }}</p>
						<div
							@click="setEditOptionIndex(childindex)"
							style="width: 500px; margin-left: 70px"
							v-for="(option, optionindex) in childItem.questionsOptionVOS"
							:key="optionindex"
						>
							<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="el_item_option item_container_title two_lines" style="display: flex">
								<el-radio label="1">
									<el-input placeholder="选项1" @focus="showAdvance" v-model="option.labelName" @blur="wjupdoption(option)"></el-input>
									<input type="text" v-if="childItem.ifFillEmpty == 1" class="inputStyle" />
								</el-radio>
								<i
									class="el-icon-s-tools el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjsetquestionoption(question.groupingOptionList, childItem, childindex)"
								></i>
								<i
									class="el-icon-remove el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjdelquestionoption(question.groupingOptionList, option, optionindex)"
								></i>
							</el-col>
						</div>
					</el-row>
				</div>
				<div
					v-if="question.choiceLayout == 3"
					style="
            display: flex;
            margin-left: 34px;
            width: 1000px;
            flex-wrap: wrap;
          "
				>
					<el-row :gutter="10" style="margin-top: 12px !important" v-for="(childItem, childindex) in question.groupingOptionList" :key="index + '_' + childindex">
						<p style="font-size: 14px; width: 100px; margin-left: 50px">{{ childItem.groupName }}</p>
						<div @click="setEditOptionIndex(childindex)" style="width: 300px" v-for="(option, optionindex) in childItem.questionsOptionVOS" :key="optionindex">
							<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="el_item_option item_container_title two_lines" style="display: flex">
								<el-radio label="1">
									<el-input placeholder="选项1" @focus="showAdvance" v-model="option.labelName" @blur="wjupdoption(option)"></el-input>
									<input type="text" v-if="childItem.ifFillEmpty == 1" class="inputStyle" />
								</el-radio>
								<i
									class="el-icon-s-tools el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjsetquestionoption(question,question.groupingOptionList, childItem, childindex)"
								></i>

								<i
									class="el-icon-remove el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjdelquestionoption(question.groupingOptionList, option, optionindex)"
								></i>
							</el-col>
						</div>
					</el-row>
				</div>
			</div>
		</div>

		<div v-if="question.ifGrouping == 0">
			<!-- 单选 -->
			<div v-if="question.ifMustSingle == 1" style="width: 1000px">
				<div v-if="question.choiceLayout == 1">
					<el-row :gutter="10" style="margin-top: 12px !important" v-for="(childItem, childindex) in question.optionList" :key="index + '_' + childindex">
						<div @click="setEditOptionIndex(childindex)">
							<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="el_item_option item_container_title two_lines" style="margin-left: 50px">
								<el-radio label="1">
									<el-input placeholder="选项1" @focus="showAdvance" v-model="childItem.labelName" @blur="wjupdoption(childItem)"></el-input>
									<input type="text" v-if="childItem.ifFillEmpty == 1" class="inputStyle" />
								</el-radio>
								<i
									class="el-icon-s-tools el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click.stop="wjsetquestionoption(question.optionList, childItem, childindex)"
								></i>
								<i
									class="el-icon-remove el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjdelquestionoption(question.optionList, childItem, childindex)"
								></i>
							</el-col>
						</div>
					</el-row>
				</div>
				<div
					v-if="question.choiceLayout == 2"
					style="
            display: flex;
            margin-left: 34px;
            width: 1000px;
            flex-wrap: wrap;
          "
				>
					<el-row :gutter="10" style="margin-top: 12px !important" v-for="(childItem, childindex) in question.optionList" :key="index + '_' + childindex">
						<div @click="setEditOptionIndex(childindex)" style="width: 500px">
							<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="el_item_option item_container_title two_lines" style="display: flex; margin-left: 50px">
								<el-radio label="1">
									<el-input placeholder="选项1" @focus="showAdvance" v-model="childItem.labelName" @blur="wjupdoption(childItem)"></el-input>
									<input type="text" v-if="childItem.ifFillEmpty == 1" class="inputStyle" />
								</el-radio>
								<i
									class="el-icon-s-tools el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjsetquestionoption(question.optionList, childItem, childindex)"
								></i>
								<i
									class="el-icon-remove el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjdelquestionoption(question.optionList, childItem, childindex)"
								></i>
							</el-col>
						</div>
					</el-row>
				</div>
				<div
					v-if="question.choiceLayout == 3"
					style="
            display: flex;
            margin-left: 34px;
            width: 1000px;
            flex-wrap: wrap;
          "
				>
					<el-row :gutter="10" style="margin-top: 12px !important" v-for="(childItem, childindex) in question.optionList" :key="index + '_' + childindex">
						<div @click="setEditOptionIndex(childindex)" style="width: 300px">
							<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="el_item_option item_container_title two_lines" style="display: flex; margin-left: 50px">
								<el-radio label="1">
									<el-input placeholder="选项1" @focus="showAdvance" v-model="childItem.labelName" @blur="wjupdoption(childItem)"></el-input>
									<input type="text" v-if="childItem.ifFillEmpty == 1" class="inputStyle" />
								</el-radio>
								<i
									class="el-icon-s-tools el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjsetquestionoption(question.optionList, childItem, childindex)"
								></i>
								<i
									class="el-icon-remove el-icon-common-option"
									v-if="editOptionIndex == index + '_' + childindex"
									@click="wjdelquestionoption(question.optionList, childItem, childindex)"
								></i>
							</el-col>
						</div>
					</el-row>
				</div>
			</div>
		</div>

		<el-row :gutter="10" style="margin-top: 12px !important" v-if="index == editIndex">
			<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="el_item_option item_container_title" style="margin-left: 50px">
				<i class="el-icon-plus el-icon-common" @click="wjaddquestionoption(question.optionList, question, 0)">添加选项</i>
				<i class="el-icon-s-fold el-icon-common" @click="batchAdd(question.optionList, question)">批量添加</i>
				<i class="el-icon-menu el-icon-common" @click="wjaddquestionoption(question.optionList, question, 1)">添加【其他】</i>
			</el-col>
		</el-row>
	</div>
</template>
<script>
export default {
	data() {
		return {
			editOptionIndex: '0_0',
			set: 'set'
		};
	},
	props: {
		number: { type: Number, default: 0 },
		question: {},
		editIndex: { type: Number, default: 0 },
		isExistPage: { type: Boolean, default: false },
		index: { type: Number, default: 0 }
	},
	methods: {
		batchAdd(options, item) {
			this.$emit('batchAdd', options, item);
		},
		wjsetquestionoption(questionsSonList,options, item, childindex, childItem) {
			this.$emit('wjsetquestionoption', options, item, childindex, childItem);
			this.$emit(
				"setrect",
				questionsSonList,
				options,
				item,
				childindex,
				this.set,
				this.question.id
			);
		},
		wjupdoption(item) {
			this.$emit('wjupdoption', item);
		},
		updateQuestion() {
			this.$emit('wjupdquestionoption', this.question);
		},
		wjaddquestionoption(optionList, item, type = 1) {
			this.$emit('wjaddquestionoption', optionList, item, type);
		},
		showAdvance(e) {
			this.$emit('showAdvance', e);
		},
		setEditIndex(index) {
			this.$emit('setEditIndex', index);
		},
		setEditOptionIndex(childIndex) {
			this.editOptionIndex = this.editIndex + '_' + childIndex;
		},
		wjdelquestionoption(options, item, childindex) {
			this.$emit('wjdelquestionoption', options, item, childindex);
		},
		questiondel(id) {
			this.$emit('questiondel', id);
		}
	},
	created() {
		// console.log('question对象',this.question)
	}
};
</script>

<style scoped>
/*.duoxuan{
  overflow-x:scroll;
}
.duoxuan::-webkit-scrollbar {
  width: 1px;
  height: 10px;
    background-color:#fff
}
.duoxuan::-webkit-scrollbar-thumb{
  background-color:rgb(238, 238, 238)
}  */
/deep/.el-input {
	width: 61% !important;
}
.inputStyle {
	border: 1px solid #cccccc !important;
	width: 50px;
	height: 25px;
}
/*输入框input*/
/deep/.two_lines .el-input__inner {
	width: 80px !important;
}
.delete,
.item {
	font-size: 22px !important;
	line-height: 40px !important;
	margin-right: 30px !important;
	text-align: right;
	float: right;
	cursor: pointer;
}
.item .el-badge__content.is-fixed {
	top: 10px;
}
.item.drag-handle{
  cursor: move;
}
.el_item_option {
	line-height: 40px;
	height: 44px;
}

.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.askxh {
	line-height: 40px;
	text-align: right;
}

.item_container_title {
	padding-left: 0px !important;
	padding-right: 0px !important;
}

/* .item_container_title:hover {
border: 1px darkgrey dashed; 
} */
.title-input {
	display: inline-block;
	width: 100%;
	line-height: 40px;
	color: #606266;
	font: 400 13.3333px Arial;
	padding: 10px 15px 0 15px;
}
</style>
